import React, { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { FaCashRegister } from "react-icons/fa";
import { GoAlertFill } from "react-icons/go";
import "./index.css";
import { getUser,formatCurrency, getCashStatus, sqlDateFormat } from "../../../../utils/Common";
import { useCash } from "../../../../hooks/useCash";
import Swal from "sweetalert2";
import Spinner from "../../../../components/Spinner";
import { useCashStatus } from "../../../../contexts/cash";
import CajaCard from "../../../../components/ui/CajaCard/index.jsx";
import { useFirebaseRealtime } from "../../../../hooks/useFirebaseRealtime";

const OpenCloseCash = () => {
  const { getCashBoxStatus, openCloseCash, getCashBoxMovements } = useCash();
  const { setCashStatus } = useCashStatus();
  const [infoCash, setInfoCash] = useState([]);
  const [currentBalances, setCurrentBalances] = useState({});
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState({});
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [totalBalance, setTotalBalance] = useState(0);
  const [showReportAlert, setShowReportAlert] = useState(true);
  const { data: realtimeData, loading, error } = useFirebaseRealtime('cash');
  const user = getUser();

  const validateAndUpdateBalance = async (balance, caja) => {
    try {
             // Validar entrada
       let numericBalance = parseFloat(balance);
      if (isNaN(numericBalance)) {
        setAlertMessage("Por favor, ingresa un saldo válido.");
        return false;
      }
      
             // Obtener balance actualizado sin actualizar todo el estado
       const abortController = new AbortController();
       const response = await getCashBoxStatus(abortController.signal);
       const updatedCaja = response?.cajas?.find(c => c.IdCaja === caja.IdCaja);
       const updatedBalance = updatedCaja?.SaldoCaja ?? balance;
       
       // Confirmar si hay cambio de balance
       if (balance !== updatedBalance) {
         const confirmed = await Swal.fire({
           title: 'El saldo de la caja ha sido actualizado',
           html: `El nuevo saldo es <strong>${formatCurrency(updatedBalance)}</strong>. <br> ¿Desea continuar?`,
           icon: 'info',
           showCancelButton: true,
           confirmButtonText: 'Aceptar',
           cancelButtonText: 'Cancelar',
           customClass: {
             confirmButton: "custom-confirm-button",
             cancelButton: "custom-cancel-button",
           },
         });
                   if (!confirmed.isConfirmed) return false;
          balance = updatedBalance;
          // Recalcular numericBalance con el nuevo valor
          numericBalance = parseFloat(updatedBalance);
          // Actualizar también los datos de la caja para la siguiente validación
          if (updatedCaja) {
            caja = { ...caja, ...updatedCaja };
          }
        }
      
      // Validar diferencia con balance anterior
      const oldBalance = (caja.EstatusCaja === 1 ? caja.UltimoSaldoApertura : caja.UltimoSaldoCierre) ?? 0;
      const statusText = caja.EstatusCaja === 1 ? 'apertura' : 'cierre';
      
      if (Number(oldBalance) !== numericBalance) {
        const confirmed = await Swal.fire({
          title: "¡Atención!",
          html: `El saldo actual (<strong>${formatCurrency(numericBalance)}</strong>) no coincide con el último saldo de ${statusText} (<strong>${formatCurrency(oldBalance)}</strong>). <br> ¿Proceder igualmente?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "custom-confirm-button",
            cancelButton: "custom-cancel-button",
          },
        });
        return confirmed.isConfirmed ? balance : false;
      }
      
      return balance;
      
         } catch (error) {
       setAlertMessage(error.message || "Error de validación");
       return false;
     }
  };

  const handleErrorResponse = (response) => {
    if (response.code >= 400) {
        switch (response.message) {
            case "CASHBOX_ALREADY_OPEN":
                return {
                    title: "¡La caja ya está abierta!",
                    text: "Actualizando estado de la caja..."
                };
            case "CASHBOX_ALREADY_CLOSED":
                return {
                    title: "¡La caja ya está cerrada!",
                    text: "Actualizando estado de la caja..."
                };
            case "MUST_GENERATE_REPORT_BEFORE_OPENING":
                return {
                  title: "¡Informe de cierre de caja requerido!",
                  text: "Se deben generar los informes de cierre de caja de todos los movimientos realizados para poder proceder."
              };
            case "REPORT_TOTALS_DO_NOT_MATCH_TRANSACTIONS":
                return {
                    title: "¡Diferencia en los totales!",
                    text: "Por favor, verifica que se hayan generado todos los reportes de cierre de caja en el ultimo turno."
                };
            case "CASHBOX_AMOUNT_NOT_MATCH":
                return {
                  title: "¡Diferencia en el saldo de caja!",
                  text: "Por favor, actualiza el saldo de la caja para continuar."
                };
            case "CASHBOX_NOT_ACTIVE":
                return {
                  title: "¡Caja desactivada!",
                  text: "Por favor, contacta al administrador para activar la caja."
                };
            default:
                return {
                    title: "Ops! Algo salió mal.",
                    text: "Por favor, inténtalo de nuevo."
                };
        }
    }
    return {
        title: "Ops! Algo salió mal.",
        text: "Por favor, inténtalo de nuevo."
    };
};
  
  const handleOpenCloseCash = async (typeMov, caja) => {
    try {
      setIsLoading(prev => ({ ...prev, [caja.IdCaja]: true }));
      let balanceToUse = currentBalances[caja.IdCaja] === "" ? caja.SaldoCaja : currentBalances[caja.IdCaja];
      const updatedBalance = await validateAndUpdateBalance(balanceToUse, caja);
      balanceToUse = updatedBalance; 

             if (balanceToUse === false || balanceToUse === undefined || balanceToUse === null || balanceToUse === "") {
        setIsLoading(prev => ({ ...prev, [caja.IdCaja]: false }));
        return;
      }
  
      const abortController = new AbortController();
      const response = await openCloseCash(abortController.signal, { typeMov, amount: Number(balanceToUse), idCashBox: caja.IdCaja });

       if (response.code === 200) {
        Swal.fire({
          title: "¡Operación completada!",
          text: typeMov === 1 ? "Se abrió la caja correctamente" : "Se cerró la caja correctamente",
          icon: "success",
          timer: 1300,
          timerProgressBar: true,
          showCancelButton: false,
          showConfirmButton: false,
        });
                   setCurrentBalances(prev => ({ ...prev, [caja.IdCaja]: "" }));
          setAlertMessage("");
          handleGetinfoCashBox();
          setIsLoading(prev => ({ ...prev, [caja.IdCaja]: false }));
       } else {
        const errorResponse = handleErrorResponse(response);
        
        // Para errores específicos de estado de caja, no limpiamos el balance inmediatamente
        if (response.message === "CASHBOX_ALREADY_OPEN" || response.message === "CASHBOX_ALREADY_CLOSED") {

          Swal.fire({
              title: errorResponse.title,
              text: errorResponse.text,
              icon: 'warning',
              showCancelButton: false,
              timer: 3000,
              timerProgressBar: true,
                             didOpen: () => {
                   Swal.showLoading();
                   handleGetinfoCashBox();
               },
                       });
            setIsLoading(prev => ({ ...prev, [caja.IdCaja]: false }));
          } else {
          // Para otros errores, limpiamos el balance como antes
          setCurrentBalances(prev => ({ ...prev, [caja.IdCaja]: "" }));
          Swal.fire({
              title: errorResponse.title,
              text: errorResponse.text,
              icon: 'warning',
              showCancelButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
              },
                     });
           setIsLoading(prev => ({ ...prev, [caja.IdCaja]: false }));
         }
      }
         } catch (error) {
       setIsLoading(prev => ({ ...prev, [caja.IdCaja]: false }));
       setCurrentBalances(prev => ({ ...prev, [caja.IdCaja]: "" }));
       setAlertMessage(error.message || "Ops! Algo salió mal. Por favor, inténtalo de nuevo.");
     }
  };

  const handleGetinfoCashBox = async () => {
      const abortController = new AbortController();
      // Ahora response es el payload directamente: { cajas, totalCajas }
      const response = await getCashBoxStatus(abortController.signal);
      const cashMovements = await getCashBoxMovements(abortController.signal, [1, 2]);
    
      if (response?.cajas) {
        const updatedInfoCash = response.cajas.map(caja => {
          const movement = cashMovements.payload.find(mov => mov.IdCaja === caja.IdCaja);
          return {
            ...caja,
            IdTipoMovimiento: movement?.IdTipoMovimiento,
            FechaMovimientoCajeroType: movement?.FechaMovimientoCajeroType,
            MontoMovimiento: movement?.MontoMovimiento,
            UltimoSaldoCierre: movement?.SaldoAnteriorCierre,
            UltimoSaldoApertura: movement?.SaldoAnteriorApertura,
          };
        });
        setInfoCash(updatedInfoCash || []);
  
        setTotalBalance(response.totalCajas ?? 0);
        const status = getCashStatus(response.cajas[0]?.EstatusCaja);
        setCashStatus(status);
        const balances = response.cajas.reduce((acc, caja) => {
          acc[caja.IdCaja] = caja.SaldoCaja;
          return acc;
        }, {});
        setCurrentBalances(balances);
        setIsDataLoading(false);
        return balances;
      } else {
        setAlertMessage("Error al obtener información de la caja");
      }
      setIsDataLoading(false);
    };

  const handleReloadCashStatus = async (cashId) => {
    setIsLoading(prev => ({ ...prev, [cashId]: true }));
    await handleGetinfoCashBox();
    setIsLoading(prev => ({ ...prev, [cashId]: false }));
    Swal.fire({
        title: 'Actualizado!',
        text: 'El estado de la caja ha sido actualizado.',
        icon: 'success',
        timer: 1500, 
        showConfirmButton: false, 
      });
  };

  const LoadingSpinner = () => {
    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                padding: 20,
                right: 0,
                left: 0,
                backgroundColor: "rgb(0 0 0 / 81%)",
                height: "100vh",
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
            }}
            className="text-left"
        >
            <Spinner type={1} size={40} color="white" />
        </div>
    );
};

  useEffect(() => {
    if (!realtimeData || infoCash.length === 0) return;
    
    const userCaja = infoCash[0];
    const firebaseUpdate = realtimeData[userCaja?.IdCaja];
    
    if (firebaseUpdate && userCaja) {
      const hasStatusChange = firebaseUpdate.status !== null && userCaja.EstatusCaja !== firebaseUpdate.status;
      const hasBalanceChange = firebaseUpdate.balance !== null && userCaja.SaldoCaja !== firebaseUpdate.balance;
      const hasRequestChange = firebaseUpdate.hasPendingRequest !== null && userCaja.hasPendingRequest !== firebaseUpdate.hasPendingRequest;
      
      if (hasStatusChange || hasBalanceChange || hasRequestChange) {

        const updatedCaja = {
          ...userCaja,
          EstatusCaja: firebaseUpdate.status !== null ? firebaseUpdate.status : userCaja.EstatusCaja,
          SaldoCaja: firebaseUpdate.balance !== null ? firebaseUpdate.balance : userCaja.SaldoCaja,
          hasPendingRequest: firebaseUpdate.hasPendingRequest !== null ? firebaseUpdate.hasPendingRequest : userCaja.hasPendingRequest,
        };
        
        setInfoCash([updatedCaja]);
        
        setCurrentBalances(prev => ({
          ...prev,
          [userCaja.IdCaja]: updatedCaja.SaldoCaja
        }));
        
        const status = getCashStatus(updatedCaja.EstatusCaja);
        setCashStatus(status);
        
      }
    }
  }, [realtimeData, infoCash]);

  useEffect(() => {
    handleGetinfoCashBox();
  }, []);

   return (
    <>
      <div className="dashboardCard text-left" style={{ color: "black", marginBottom: "20px" }}>
        <div className="d-flex" style={{ gap: 20 }}>
          <div className="d-flex align-items-center">
            <FaCashRegister size={20} className="mr-2" />
            <h5 className="mb-0">Estado de caja</h5>
          </div>
        </div>
      </div>
      {/* Alerta informativa */}
      {showReportAlert  && (
        <div className="dashboardCard p-0">
          <div className="alert alert-warning"
            style={{
              marginBottom: 20,
              fontWeight: 600,
              fontSize: 16,
              background: "#fffbe6",
              border: "1px solid #ffe58f",
              color: "#ad8b00",
              position: "relative",
            }}
          >
            <button
              type="button"
              onClick={() => setShowReportAlert(false)}
              className="d-flex align-items-center"
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "transparent",
                border: "none",
                fontSize: 20,
                fontWeight: "bold",
                color: "red",
                cursor: "pointer",
                lineHeight: 1,
              }}
              aria-label="Cerrar"
            >
              ×
            </button>
            Recuerda: En caso de que el saldo en caja sea bajo, es necesario realizar el cierre de caja y generar el informe correspondiente. Una vez enviado, se podrá proceder con la asignación de un nuevo saldo.
          </div>
        </div>
      )}

      {isDataLoading ? (
        <div className="text-left m-3" style={{ color: "black", marginBottom: "20px" }}>
           <LoadingSpinner />
        </div>
      ) : (
        infoCash.map((caja, index) => (
          <CajaCard
            key={index}
            caja={caja}
            isLoading={isLoading}
            handleOpenCloseCash={handleOpenCloseCash}
            handleReloadCashStatus={handleReloadCashStatus}
            showAddWithdrawButtons={false}
            roleBli={user.roleId}
            rotate={true}
          />
        ))
      )}
  
      <CSSTransition
        in={!!alertMessage}
        timeout={300}
        classNames="alert"
        unmountOnExit
      >
        <div className="p-4">
          <div className="banner-alert-cash">
            <div className="banner-message">
              <GoAlertFill className="mr-2" size={20} />
              {alertMessage}
            </div>
            <div
              className="banner-close-btn"
              onClick={() => setAlertMessage("")}
            >
              ✖
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default OpenCloseCash;